import request from '@core/services/request';

export const serviceLookupAPI = {
	sendOTP: (phoneNumber: any) => request.post(`/ServiceLookup/SendOTP?phoneNumber=${phoneNumber}`),
	verifyOTP: (submittedCode: any, verificationSid: any) => request.post(`/ServiceLookup/VerifyOTP?code=${submittedCode}&sid=${verificationSid}`),
	getDealsForService: (searchRequest: any) => request.post(`/ServiceLookup/GetDealsForService`, searchRequest),
	getDealForService: (storeCode: any, dealNumber: any) => request.get(`/ServiceLookup/GetDealForService?storeCode=${storeCode}&dealNumber=${dealNumber}`),
	getLookups: () => request.get(`/ServiceLookup/GetLookups`),
	getDocumentBytes: (filePath: any) => request.get(`/ServiceLookup/GetDocumentBytes?filePath=${filePath}`),
};
